(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-ch-root]').forEach(function(root){
      // Announcement rotator
      var items = root.querySelectorAll('[data-ch-announce] .ch__announce-item');
      if (items.length > 1) {
        var idx = 0;
        setInterval(function(){
          items[idx].classList.remove('is-active');
          idx = (idx + 1) % items.length;
          items[idx].classList.add('is-active');
        }, 4500);
      }

      // Search toggle
      var searchToggle = root.querySelector('[data-ch-search-toggle]');
      var searchOverlay = root.querySelector('[data-ch-search]');
      var searchClose = root.querySelector('[data-ch-search-close]');
      if (searchToggle && searchOverlay) {
        searchToggle.addEventListener('click', function(){
          searchOverlay.classList.toggle('is-open');
          if (searchOverlay.classList.contains('is-open')) {
            setTimeout(function(){ var i = searchOverlay.querySelector('input'); if (i) i.focus(); }, 100);
          }
        });
      }
      if (searchClose && searchOverlay) {
        searchClose.addEventListener('click', function(){ searchOverlay.classList.remove('is-open'); });
      }

      // Mobile drawer
      var burger = root.querySelector('[data-ch-burger]');
      var drawer = root.querySelector('[data-ch-drawer]');
      var drawerClose = root.querySelector('[data-ch-drawer-close]');
      var overlay = root.querySelector('[data-ch-overlay]');
      function openDrawer(){
        drawer.classList.add('is-open'); overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
      function closeDrawer(){
        drawer.classList.remove('is-open'); overlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }
      if (burger) burger.addEventListener('click', openDrawer);
      if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);

      // Drawer submenu accordions
      drawer.querySelectorAll('[data-ch-drawer-toggle]').forEach(function(btn){
        btn.addEventListener('click', function(){
          var item = btn.closest('.ch__drawer-item');
          item.classList.toggle('is-open');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fabric-collections"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.fabric-collections--layout-carousel').forEach(function(root){
      var wrap = root.querySelector('.fabric-collections__grid-wrap');
      var grid = root.querySelector('.fabric-collections__grid');
      if (!wrap || !grid) return;
      var prevBtn = wrap.querySelector('[data-fabric-nav="prev"]');
      var nextBtn = wrap.querySelector('[data-fabric-nav="next"]');

      function scrollStep(){
        var card = grid.querySelector('.fabric-card');
        if (!card) return grid.clientWidth * 0.8;
        var styles = window.getComputedStyle(grid);
        var gap = parseInt(styles.columnGap || styles.gap || '14', 10);
        return card.getBoundingClientRect().width + gap;
      }
      function updateNavState(){
        if (!prevBtn || !nextBtn) return;
        prevBtn.disabled = grid.scrollLeft <= 2;
        nextBtn.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
      }
      if (prevBtn) prevBtn.addEventListener('click', function(){
        grid.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
      if (nextBtn) nextBtn.addEventListener('click', function(){
        grid.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
      grid.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState);
      updateNavState();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.fpc__track-wrap').forEach(function(wrap){
      var track = wrap.querySelector('.fpc__track');
      if (!track) return;
      var prevBtn = wrap.querySelector('[data-fpc-nav="prev"]');
      var nextBtn = wrap.querySelector('[data-fpc-nav="next"]');

      function scrollStep(){
        var card = track.querySelector('.fpc__card');
        if (!card) return track.clientWidth * 0.8;
        var styles = window.getComputedStyle(track);
        var gap = parseInt(styles.columnGap || styles.gap || '12', 10);
        return card.getBoundingClientRect().width + gap;
      }
      function updateNavState(){
        if (!prevBtn || !nextBtn) return;
        prevBtn.disabled = track.scrollLeft <= 2;
        nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      if (prevBtn) prevBtn.addEventListener('click', function(){
        track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
      if (nextBtn) nextBtn.addEventListener('click', function(){
        track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState);
      updateNavState();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-delivery-estimator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('.product-delivery');

    sections.forEach((section) => {
      const btn = section.querySelector('[data-pincode-check]');
      if (!btn) {
        updateDeliveryDate(section);
        return;
      }

      const sectionId = btn.getAttribute('data-pincode-check');
      const input = section.querySelector(`#product-delivery-pin-${sectionId}`);
      const result = section.querySelector(`#product-delivery-result-${sectionId}`);

      updateDeliveryDate(section);

      btn.addEventListener('click', () => {
        const val = (input && input.value || '').trim();
        if (!/^\d{6}$/.test(val)) {
          result.textContent = 'Please enter a valid 6-digit pincode';
          result.classList.remove('is-success');
          result.classList.add('is-error');
          return;
        }

        const days = deliveryDaysForPincode(val);
        const estimate = formatDeliveryDate(days);
        result.textContent = `Delivery to ${val} expected by ${estimate}`;
        result.classList.remove('is-error');
        result.classList.add('is-success');
      });
    });

    function updateDeliveryDate(section) {
      const el = section.querySelector('[id^="product-delivery-date-"]');
      if (!el) return;
      const template = el.textContent || '';
      if (template.indexOf('{date}') === -1) return;
      el.textContent = template.replace('{date}', formatDeliveryDate(4));
    }

    function deliveryDaysForPincode(pin) {
      const first = parseInt(pin.charAt(0), 10);
      if (first <= 2) return 3;
      if (first <= 5) return 4;
      return 6;
    }

    function formatDeliveryDate(days) {
      const d = new Date();
      d.setDate(d.getDate() + days);
      return d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-urgency"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.currentScript && document.currentScript.closest('.product-urgency');
    const root = section || document.querySelector('.product-urgency');
    if (!root) return;

    const min = parseInt(root.dataset.viewersMin, 10) || 5;
    const max = parseInt(root.dataset.viewersMax, 10) || 30;
    const counter = root.querySelector('.product-urgency__viewers-count');
    if (!counter) return;

    function randomInRange(a, b) {
      return Math.floor(Math.random() * (b - a + 1)) + a;
    }

    counter.textContent = randomInRange(min, max);

    setInterval(() => {
      counter.textContent = randomInRange(min, max);
    }, 8000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collections"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('[data-tcoll]').forEach(function(root){
      var tabs = root.querySelectorAll('.tcoll__tab');
      var panels = root.querySelectorAll('.tcoll__panel');
      var viewAll = root.querySelector('[data-tcoll-view-all]');
      var prevBtn = root.querySelector('[data-tcoll-nav="prev"]');
      var nextBtn = root.querySelector('[data-tcoll-nav="next"]');

      function activeGrid(){
        var panel = root.querySelector('.tcoll__panel.is-active') || panels[0];
        return panel ? panel.querySelector('.tcoll__grid') : null;
      }
      function scrollStep(){
        var grid = activeGrid();
        if (!grid) return 300;
        var card = grid.querySelector('.tcoll__card');
        if (!card) return grid.clientWidth * 0.8;
        var styles = window.getComputedStyle(grid);
        var gap = parseInt(styles.columnGap || styles.gap || '16', 10);
        return card.getBoundingClientRect().width + gap;
      }
      function updateNavState(){
        var grid = activeGrid();
        if (!grid || !prevBtn || !nextBtn) return;
        prevBtn.disabled = grid.scrollLeft <= 2;
        nextBtn.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
      }
      if (prevBtn) prevBtn.addEventListener('click', function(){
        var grid = activeGrid();
        if (grid) grid.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
      if (nextBtn) nextBtn.addEventListener('click', function(){
        var grid = activeGrid();
        if (grid) grid.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
      panels.forEach(function(panel){
        var grid = panel.querySelector('.tcoll__grid');
        if (grid) grid.addEventListener('scroll', updateNavState, { passive: true });
      });
      window.addEventListener('resize', updateNavState);
      updateNavState();

      function syncViewAll(tab){
        if (!viewAll) return;
        var url = tab.getAttribute('data-tab-url');
        if (url && url.length > 0) {
          viewAll.setAttribute('href', url);
          viewAll.style.display = '';
        } else {
          viewAll.style.display = 'none';
        }
      }

      // Initialize from the active tab on load
      var activeTab = root.querySelector('.tcoll__tab.is-active') || tabs[0];
      if (activeTab) syncViewAll(activeTab);

      tabs.forEach(function(tab){
        tab.addEventListener('click', function(){
          var target = tab.getAttribute('data-tab-target');
          tabs.forEach(function(t){
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          panels.forEach(function(p){
            if (p.id === target) p.classList.add('is-active');
            else p.classList.remove('is-active');
          });
          syncViewAll(tab);
          updateNavState();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
